<template>
    <rkm-wizard @finish="handleFinish">
        <rkm-wizard-tab
            :before-change="() => $refs.FormDados.validate()"
            icon="fas fa-id-card-alt"
            title="Dados pessoais"
        >
            <FormDados
                :additionals="additionals"
                :form="form"
                :model="model"
                ref="FormDados"
            />
        </rkm-wizard-tab>

        <rkm-wizard-tab
            :before-change="() => $refs.FormDocumentos.validate()"
            icon="fas fa-file-contract"
            title="Documentos"
        >
            <FormDocumentos
                :additionals="additionals"
                :form="form"
                :model="model"
                ref="FormDocumentos"
            />
        </rkm-wizard-tab>

        <rkm-wizard-tab
            :before-change="() => $refs.FormContatos.validate()"
            icon="fas fa-file-contract"
            title="Contatos"
        >
            <FormContatos
                :model="model"
                ref="FormContatos"
            />
        </rkm-wizard-tab>

        <rkm-wizard-tab
            :before-change="() => $refs.FormEndereco.validate()"
            icon="fas fa-map-marker-alt"
            title="Endereço"
        >
            <FormEndereco
                :additionals="additionals"
                :form="form"
                :model="model"
                ref="FormEndereco"
            />
        </rkm-wizard-tab>

        <rkm-wizard-tab
            :before-change="() => $refs.FormInformacoesComplementares.validate()"
            icon="fas fa-map-marker-alt"
            title="Informações complementares"
        >
            <FormInformacoesComplementares
                :form="form"
                :model="model"
                ref="FormInformacoesComplementares"
            />
        </rkm-wizard-tab>
    </rkm-wizard>
</template>

<script>
// Components.
import FormContatos from './components/contatos/Form'
import FormDados from './components/dados/Form'
import FormDocumentos from './components/documentos/Form'
import FormEndereco from './components/endereco/Form'
import FormInformacoesComplementares from './components/informacoes-complementares/Form'

export default {
    components: {
        FormContatos,
        FormDados,
        FormDocumentos,
        FormEndereco,
        FormInformacoesComplementares,
    },
    methods: {
        handleFinish() {
            this.$refs.FormInformacoesComplementares.validate()
                .then(validated => {
                    if (validated) {
                        this.$emit('finish')
                    }
                })
        },
    },
    props: {
        additionals: {type: Object, required: true},
        form: {type: Object, required: true},
        model: {type: Object, required: true},
    },
}
</script> 